export default "__VITE_ASSET__af93bde6__"